import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';

@Injectable()
export class SystemService {

    constructor(private http: Http) { }

    getVersion() {
        return this.http.get('assets/version.json')
            .map((data: Response) => data.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/system.service.ts